"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "BrightSignMetricsProvider", {
  enumerable: true,
  get: function () {
    return _BrightSignMetricsProvider.default;
  }
});
Object.defineProperty(exports, "ChromeOSMetricsProvider", {
  enumerable: true,
  get: function () {
    return _ChromeOSMetricsProvider.default;
  }
});
Object.defineProperty(exports, "DeviceManufacturer", {
  enumerable: true,
  get: function () {
    return _DeviceType.DeviceManufacturer;
  }
});
Object.defineProperty(exports, "DeviceMetricsProvider", {
  enumerable: true,
  get: function () {
    return _provider.default;
  }
});
Object.defineProperty(exports, "DeviceMetricsProviderFactory", {
  enumerable: true,
  get: function () {
    return _factory.default;
  }
});
Object.defineProperty(exports, "DeviceType", {
  enumerable: true,
  get: function () {
    return _DeviceType.default;
  }
});
Object.defineProperty(exports, "XumoMetricsProvider", {
  enumerable: true,
  get: function () {
    return _XumoMetricsProvider.default;
  }
});
Object.defineProperty(exports, "collectDeviceMetrics", {
  enumerable: true,
  get: function () {
    return _collect.collectDeviceMetrics;
  }
});
var _provider = _interopRequireDefault(require("./provider"));
var _factory = _interopRequireDefault(require("./factory"));
var _BrightSignMetricsProvider = _interopRequireDefault(require("./providers/brightsign/BrightSignMetricsProvider"));
var _XumoMetricsProvider = _interopRequireDefault(require("./providers/xumo/XumoMetricsProvider"));
var _ChromeOSMetricsProvider = _interopRequireDefault(require("./providers/chromeos/ChromeOSMetricsProvider"));
var _DeviceType = _interopRequireWildcard(require("./DeviceType"));
var _collect = require("./collect");
var cache;
function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var r, c, a = Object.defineProperty, n = { __proto__: null, default: e }; if (Object(e) !== e) return n; if (cache || "function" != typeof WeakMap || (cache = new WeakMap()), cache) { if (cache.has(e)) return cache.get(e); cache.set(e, n); } for (c in e) "default" !== c && {}.hasOwnProperty.call(e, c) && ((r = a && Object.getOwnPropertyDescriptor(e, c)) && (r.get || r.set) ? a(n, c, r) : n[c] = e[c]); return n; }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }